import { Observable } from 'rxjs';
import { ApiUrl } from '../api-core/api-constants';
import { apiGet, apiPost } from '../api-core/api-request';
import apiResourceHookFactory from '../api-core/utility-factories/api-resource-hook-factory';
import apiItemHookFactory from '../api-core/utility-factories/api-item-hook-factory';
import { apiRedux } from '../api-redux';
import {
  CompetitionTerms,
  Referral,
  ReferralData,
  ReferralReq,
} from './api-referral.types';

// eslint-disable-next-line import/prefer-default-export
export const useCreateReferral = apiItemHookFactory(
  apiRedux.createReferral,
  ({ redirectTo }: ReferralReq): Observable<Referral> =>
    apiPost<Referral>(ApiUrl.REFERRAL_CREATE, {
      redirectTo,
    })
);

export const useGetReferralDetails = apiResourceHookFactory(
  apiRedux.getReferralDetails,
  () => apiGet<ReferralData[]>(ApiUrl.REFERRAL_DETAILS)
);

export const useGetCompetitionTerms = apiResourceHookFactory(
  apiRedux.getCompetitionTerms,
  () => apiGet<CompetitionTerms[]>(ApiUrl.COMPETITIONS_TERMS)
);
